<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addShipOnlyModal"
        persistent
        max-width="800px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              ><span class="headline">
                  {{ isUpdate ? 'Update order' : 'New order' }}
                </span></v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  &nbsp;X</v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="isDone"
              >
                {{ isUpdate ? 'Updated successfully' : 'Ordered successfully' }}
              </v-alert>
              <v-layout wrap>
                <!-- <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <branch-select
                    :disabled="isUpdate"
                    v-model="form.branch_id_fk"
                  />
                </v-flex> -->

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="loggedInUserData.is_staff"
                >
                  <v-select
                    autocomplete
                    :items="customers"
                    item-value="value"
                    v-model="form.customer_id_fk"
                    :error-messages="errors.collect('customer_id_fk')"
                    data-vv-name="customer_id_fk"
                    label="Customer*"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Product Name*"
                    v-model="form.product_name"
                    :error-messages="errors.collect('product_name')"
                    v-validate="'required'"
                    data-vv-name="product_name"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Product url"
                    v-model="form.product_url"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Quantity"
                    v-model="form.quantity"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="warehouses"
                    item-value="value"
                    v-model="form.warehouse_id_fk"
                    :error-messages="errors.collect('warehouse_id_fk')"
                    data-vv-name="warehouse_id_fk"
                    label="Warehouse*"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Weight"
                    v-model="form.item_weight"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Volume"
                    v-model="form.volume"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    label="Track number"
                    v-model="form.track_number"
                    data-vv-name="track_number"
                    @input="removeSpaces()"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                >
                  <v-text-field
                    label="Shipping"
                    v-model.number="form.internal_shipping_handling"
                    @input="calculateTotalAmount()"
                    :error-messages="errors.collect('Shipping')"
                    v-validate="'decimal:2'"
                    data-vv-name="Shipping"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                >
                  <v-text-field
                    label="Tax"
                    v-model.number="form.tax"
                    @input="calculateTotalAmount()"
                    :error-messages="errors.collect('Tax')"
                    v-validate="'decimal:2'"
                    data-vv-name="Tax"
                  />
                </v-flex>

                <v-flex
                  class="px-2 mb-2"
                  xs12
                  sm12
                  md6
                >
                  <date-picker
                    style="border-bottom-color: #919191"
                    :date="startTime"
                    :option="option"
                    class="form-control"
                  ></date-picker>
                  <span
                    v-if="fromDateError"
                    style="color: orangered"
                  ><br />From date must be greater than Today</span>
                </v-flex>

                <v-flex
                  class="px-2 mb-2"
                  xs12
                  sm12
                  md6
                >
                  <date-picker
                    style="border-bottom-color: #919191"
                    :date="startTime1"
                    :option="option1"
                    class="form-control"
                  ></date-picker>
                  <span
                    v-if="toDateError"
                    style="color: orangered"
                  ><br />To date must be greater than From date</span>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md12
                >
                  <v-text-field
                    label="Note"
                    v-model="form.note"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >Cancel</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto; margin-right: 2%"
                outline
                color="success"
              >
                {{ isUpdate ? 'Save' : 'Add' }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import myDatepicker from 'vue-datepicker'

export default {
  created() {
    this.getLoggedInUser()
  },

  components: {
    'date-picker': myDatepicker,
  },

  props: [
    'addShipOnlyModal',
    'warehouses',
    'closeAddNewOrderModal',
    'customers',
    'checkURL',
    'isUpdate',
    'formData',
  ],

  data() {
    return {
      loggedInUserData: {},
      loading: false,
      form: {},
      isDone: false,
      fromDateError: false,
      toDateError: false,
      startTime: {},
      startTime1: {},
      today: null,
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5',
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true, // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d',
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5',
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true, // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        format: 'YYYY-MM-DD HH:mm',
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
        format: 'YYYY-MM-DD HH:mm',
      },
    }
  },

  watch: {
    addShipOnlyModal: {
      immediate: false,
      handler() {
        if (this.addShipOnlyModal) {
          let t = new Date()
          let dd = t.getDate()
          let mm = t.getMonth() + 1 // January is 0!
          let yyyy = t.getFullYear()

          if (dd < 10) {
            dd = '0' + dd
          }

          if (mm < 10) {
            mm = '0' + mm
          }

          t = yyyy + '-' + mm + '-' + dd
          this.today = t

          if (this.isUpdate) {
            this.form = this.formData
            console.log(this.form)
            this.startTime.time = this.formData.from_date
            this.startTime1.time = this.formData.to_date
          } else {
            this.startTime.time = t
            this.startTime1.time = t
          }
        }
      },
    },
  },

  methods: {
    removeSpaces() {
      this.form.track_number = this.form.track_number.replaceAll(/\s+/g, '')
    },

    closeDialog() {
      this.$validator.reset()
      this.form = {}
      this.$emit('close')
    },

    calculateTotalAmount() {
      let shipping = 0
      let tax = 0
      if (this.form.internal_shipping_handling && !isNaN(this.form.internal_shipping_handling)) {
        shipping = this.form.internal_shipping_handling
      }
      if (this.form.tax && !isNaN(this.form.tax)) {
        tax = this.form.tax
      }
      this.form.total_amount = Number(shipping) + Number(tax)
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.startTime && this.startTime.time <= this.today) {
            this.toDateError = false
            this.fromDateError = true
            return
          }

          if (this.startTime1 && this.startTime && this.startTime1.time <= this.startTime.time) {
            this.fromDateError = false
            this.toDateError = true
            return
          }

          this.form.from_date = this.startTime.time
          this.form.to_date = this.startTime1.time

          if (this.isUpdate) {
            Axios.put(`api/update_ship_only_order/${this.form.order_id}`, this.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(() => {
              this.isDone = true
              this.startTime = {}
              this.startTime1 = {}
              this.form = {}
              this.toDateError = false
              this.fromDateError = false
              setTimeout(() => {
                this.isDone = false
                this.$emit('resetTable')
                this.$emit('close')
              }, 2000)
            })
          } else {
            Axios.post('api/store_ship_only_order', this.form, {
              headers: { Authorization: 'Bearer ' + token }
            }).then(res => {
              this.isDone = true
              this.startTime = {}
              this.startTime1 = {}
              this.form = {}
              this.toDateError = false
              this.fromDateError = false
              setTimeout(() => {
                this.isDone = false
                this.$emit('resetTable', res.data)
                this.$emit('close')
              }, 2000)
            })
          }
        }
      })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addShipOnly.vue